// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function ButtonBase (theme) {
	return {
		MuiButtonBase: {
			defaultProps: {
				disableRipple: true
			},
			styleOverrides: {
				root: {
					// fontSize: 'inherit',
					// '&.MuiButtonBase-root:disabled': {
					//     cursor: 'not-allowed',
					//     pointerEvents: 'auto'
					// },
				}
			}
		}
	}
}